import React from 'react';
import './BunnyLoader.css';

const BunnyLoader = ({ 
  size = 'medium', 
  text = 'Loading...', 
  showText = true, 
  animation = 'bounce',
  className = '',
  containerClassName = '',
  textClassName = ''
}) => {
  const sizeClasses = {
    small: 'text-sm',
    medium: 'text-lg', 
    large: 'text-2xl',
    xlarge: 'text-3xl'
  };

  const animationClasses = {
    bounce: 'rabbit-bounce',
    hop: 'rabbit-hop',
    wiggle: 'rabbit-wiggle',
    pulse: 'rabbit-pulse'
  };

  return (
    <div className={`flex items-center gap-2 ${containerClassName}`}>
      <div className={`${animationClasses[animation]} ${className}`}>
        <span className={sizeClasses[size]}>🐰</span>
      </div>
      {showText && (
        <span className={`text-body font-body text-subtext-color ${textClassName}`}>
          {text}
        </span>
      )}
    </div>
  );
};

export default BunnyLoader; 